function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".blog_svg__cls-1{fill:none;stroke:#2d4658;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  className: "blog_svg__cls-1",
  x: 2,
  y: 2,
  width: 28,
  height: 28,
  rx: 1.99,
  ry: 1.99
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "blog_svg__cls-1",
  d: "M5.5 20.5h21M5.5 25h21m-8-13.5h8m-8 4.46h8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#00c5ba",
  stroke: "#00c5ba",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.5 5.96h9.44v10H5.5z"
});

const SvgBlog = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "blog_svg__Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _ref, _ref2, _ref3, _ref4);

export default SvgBlog;